import React, { Component } from 'react';
import moment from 'moment';
import TopHeader from '../template/TopHeader';
import { connect } from "react-redux";
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { leaveService } from '../../_services';
import { hairdresserActions } from '../../_actions';
import toast from '../shared/Toast';

class Leave extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bookingDate: new Date(),
            startDate: new Date(),
            endDate: new Date(),
            hairdresserId: '',
            hairdresserName: 'Select Staff Member',
            leaveTitle: '',
            isSubmitting: false,
            startDateError: '',
            endDateError: '',
            hairdresserError: '',
            leaveTitleError: '',
            isEditMode: false,
            leaveId: null,
            isLoading: false,
            isMobileEnableState: true
        };
    }

    componentDidMount() {
        document.body.classList.add('leave-page-temp');
        
        // Check if we're in edit mode (URL contains holidayId)
        const holidayId = this.props.match?.params?.holidayId;
        
        // Load staff members
        const params = {
            searchKey: '',
            'hairdresserId': localStorage.getItem('userId'),
            page: 1,
            listType: 1
        };
        
        if (localStorage.getItem('accessToken')) {
            if (holidayId) {
                this.setState({
                    isEditMode: true,
                    leaveId: holidayId,
                    isLoading: true
                });
                
                // Load staff data first, then leave data
                this.props.dispatch(hairdresserActions.hairdresserStaffRota(params))
                    .then(() => {
                        return this.loadLeaveData(holidayId);
                    })
                    .catch(error => {
                        console.error('Error loading data:', error);
                        this.setState({
                            error: 'Failed to load leave data',
                            isLoading: false
                        });
                    })
                    .finally(() => {
                        this.setState({ isLoading: false });
                    });
            } else {
                // Just load staff data for new leave creation
                this.props.dispatch(hairdresserActions.hairdresserStaffRota(params));
            }
        }
    }


    componentWillUnmount() {
        document.body.classList.remove('leave-page-temp');
    }

    selectDay = (date) => {
        this.setState({
            bookingDate: date,
            startDate: date,
            endDate: date
        });
    }

    handleStartDateChange = (date) => {
        this.setState({
            startDate: date,
            endDate: date > this.state.endDate ? date : this.state.endDate,
            startDateError: ''
        });
    }

    handleEndDateChange = (date) => {
        this.setState({
            endDate: date,
            endDateError: ''
        });
    }

    changeHairdresser = (selectedOption) => {
        this.setState({
            hairdresserId: selectedOption ? selectedOption.value : '',
            hairdresserName: selectedOption ? selectedOption.label : 'Select Staff Member',
            hairdresserError: ''
        });
    }

    handleLeaveTitleChange = (e) => {
        this.setState({
            leaveTitle: e.target.value,
            leaveTitleError: ''
        });
    }

    getStaffOptions = () => {
        if (!this.props.staffRota || !this.props.staffRota.rota) {
            return [];
        }
        
        return this.props.staffRota.rota
            .filter(staff => staff.name !== 'Unknown' && staff.email !== 'Unknown')
            .map(staff => ({
                value: staff._id,
                label: staff.name
            }));
    }

    getSelectedStaffOption = () => {
        if (!this.state.hairdresserId) {
            return null;
        }
        
        const staffOptions = this.getStaffOptions();
        if (!staffOptions || staffOptions.length === 0) {
            return null;
        }
        
        const selectedOption = staffOptions.find(option => option.value === this.state.hairdresserId);
        return selectedOption || null;
    }

    handleSubmit = (e) => {
        if (e) e.preventDefault();
        
        let hasError = false;
        
        if (!this.state.startDate) {
            this.setState({ startDateError: 'Please select start date' });
            hasError = true;
        }
        
        if (!this.state.endDate) {
            this.setState({ endDateError: 'Please select end date' });
            hasError = true;
        }
        
        if (this.state.startDate > this.state.endDate) {
            this.setState({ endDateError: 'End date must be after start date' });
            hasError = true;
        }
        
        if (!this.state.hairdresserId) {
            this.setState({ hairdresserError: 'Please select staff member' });
            hasError = true;
        }
        
        if (this.state.leaveTitle && this.state.leaveTitle.length > 200) {
            this.setState({ leaveTitleError: 'Leave title must be 200 characters or less' });
            hasError = true;
        }
        
        if (hasError) return;

        this.setState({ isSubmitting: true, error: '', success: '' });

        const leaveData = {
            holidayStartDate: moment(this.state.startDate).format('YYYY-MM-DD'),
            holidayEndDate: moment(this.state.endDate).format('YYYY-MM-DD'),
            hairdresserId: this.state.hairdresserId,
            title: this.state.leaveTitle,
            deviceToken: 'web-app'
        };

        console.log('Leave data to submit:', leaveData);
        
        // Call the actual API
        leaveService.createLeave(leaveData)
            .then(response => {
                console.log('Leave API response:', response.data);
                
                // Check if the response contains an error (errorCode > 0)
                if (response.data.errorCode && response.data.errorCode > 0) {
                    // API returned an error in the response body
                    this.setState({
                        isSubmitting: false
                    });
                    toast.error(response.data.messages || 'Failed to create leave. Please try again.');
                } else {
                    // Success case
                    this.setState({
                        isSubmitting: false
                    });
                    toast.success('Leave created successfully!');
                    // Navigate back to diary page
                    this.props.history.push('/diary/' + localStorage.getItem('salonId'));
                }
            })
            .catch(error => {
                console.error('Error creating leave:', error);
                let errorMessage = 'Failed to create leave. Please try again.';
                
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                
                this.setState({
                    isSubmitting: false
                });
                toast.error(errorMessage);
            });
    }

    loadLeaveData = (leaveId) => {
        return leaveService.getLeave(leaveId)
            .then(response => {
                console.log('Leave response:', response.data);
                const leave = response.data.data.holidayInfo;
                
                // Find the staff member name from Redux state
                let hairdresserName = 'Staff Member';
                if (this.props.staffRota && this.props.staffRota.rota) {
                    const staffMember = this.props.staffRota.rota.find(staff => staff._id === leave.userId);
                    if (staffMember) {
                        hairdresserName = staffMember.name;
                    }
                }
                
                this.setState({
                    startDate: new Date(leave.startDate),
                    endDate: new Date(leave.endDate),
                    hairdresserId: leave.userId,
                    hairdresserName: hairdresserName,
                    leaveTitle: leave.title || ''
                });
                
                return response;
            })
            .catch(error => {
                console.error('Error loading leave:', error);
                toast.error('Failed to load leave data');
                throw error;
            });
    }

    updateLeave = () => {
        let hasError = false;
        
        // Reset errors
        this.setState({
            startDateError: '',
            endDateError: '',
            hairdresserError: '',
            leaveTitleError: ''
        });
        
        // Validation
        if (!this.state.startDate) {
            this.setState({ startDateError: 'Please select start date' });
            hasError = true;
        }
        
        if (!this.state.endDate) {
            this.setState({ endDateError: 'Please select end date' });
            hasError = true;
        }
        
        if (this.state.startDate > this.state.endDate) {
            this.setState({ endDateError: 'End date must be after start date' });
            hasError = true;
        }
        
        if (!this.state.hairdresserId) {
            this.setState({ hairdresserError: 'Please select staff member' });
            hasError = true;
        }
        
        if (this.state.leaveTitle && this.state.leaveTitle.length > 200) {
            this.setState({ leaveTitleError: 'Leave title must be 200 characters or less' });
            hasError = true;
        }
        
        if (hasError) return;

        this.setState({ isSubmitting: true, error: '', success: '' });

        const leaveData = {
            holidayStartDate: moment(this.state.startDate).format('YYYY-MM-DD'),
            holidayEndDate: moment(this.state.endDate).format('YYYY-MM-DD'),
            hairdresserId: this.state.hairdresserId,
            title: this.state.leaveTitle,
            deviceToken: 'web-app'
        };

        leaveService.updateLeave(this.state.leaveId, leaveData)
            .then(response => {
                console.log('Leave update API response:', response.data);
                
                // Check if the response contains an error (errorCode > 0)
                if (response.data.errorCode && response.data.errorCode > 0) {
                    // API returned an error in the response body
                    this.setState({
                        isSubmitting: false
                    });
                    toast.error(response.data.messages || 'Failed to update leave. Please try again.');
                } else {
                    // Success case
                    this.setState({
                        isSubmitting: false
                    });
                    toast.success('Leave updated successfully!');
                    // Navigate back to diary page
                    this.props.history.push('/diary/' + localStorage.getItem('salonId'));
                }
            })
            .catch(error => {
                console.error('Error updating leave:', error);
                let errorMessage = 'Failed to update leave. Please try again.';
                
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                
                this.setState({
                    isSubmitting: false
                });
                toast.error(errorMessage);
            });
    }

    deleteLeave = () => {
        console.log('deleteLeave called with leaveId:', this.state.leaveId);
        
        if (!this.state.leaveId) {
            console.error('No leaveId found');
            toast.error('No leave ID found');
            return;
        }

        leaveService.deleteLeave(this.state.leaveId)
            .then(response => {
                console.log('Leave deleted successfully:', response.data);
                if (response.data.errorCode) {
                    toast.error(response.data.messages || 'Failed to delete leave');
                } else {
                    toast.success('Leave deleted successfully');
                    this.props.history.push('/diary/' + localStorage.getItem('salonId'));
                }
            })
            .catch(error => {
                console.error('Error deleting leave:', error);
                let errorMessage = 'Failed to delete leave. Please try again.';
                
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                
                toast.error(errorMessage);
            });
    }

    saveLeave = () => {
        if (this.state.isEditMode) {
            this.updateLeave();
        } else {
            this.handleSubmit();
        }
    }

    mobileCancel = () => {
        this.props.history.push('/diary/' + localStorage.getItem('salonId'));
    }

    mobileContinue = () => {
        this.saveLeave();
    }

    isMobileEnable = () => {
        // Enable mobile continue button when form is valid
        const isValid = this.state.hairdresserId && this.state.startDate && this.state.endDate &&
                       this.state.startDate <= this.state.endDate;
        this.setState({
            isMobileEnableState: !isValid
        });
    }

    componentDidUpdate(prevProps, prevState) {
        // Update staff member name when staff data loads and we're in edit mode
        if (this.state.isEditMode && this.state.hairdresserId &&
            this.props.staffRota && this.props.staffRota.rota &&
            (!prevProps.staffRota || !prevProps.staffRota.rota)) {
            
            const staffMember = this.props.staffRota.rota.find(staff => staff._id === this.state.hairdresserId);
            if (staffMember && (this.state.hairdresserName === 'Staff Member' || this.state.hairdresserName === 'Select Staff Member')) {
                this.setState({
                    hairdresserName: staffMember.name
                });
            }
        }

        // Check mobile enable state when form data changes
        if (prevState.hairdresserId !== this.state.hairdresserId ||
            prevState.startDate !== this.state.startDate ||
            prevState.endDate !== this.state.endDate) {
            this.isMobileEnable();
        }
    }

    render() {
        const { bookingDate } = this.state;
        
        return (
            <>
            <div className="h_n">
                <div className="body_container body_bg_lightGray">
                    <TopHeader title="Leave"
                     headerButtonStatus={true}
                     cancelButton={true}
                     saveBookingButton={true}
                     saveBooking={this.saveLeave}
                     isbookingSubmit={this.state.isSubmitting}
                     saveBookingButtonText="Save Leave"
                     {...this.props}
                      />
                    
                    {!this.state.isEditMode && (
                        <nav className="nav nav-tabs _newCheckout_wrapper navbar__space">
                            <span
                                className="nav-item nav-link"
                                onClick={() => this.props.history.push(`/newbooking/${this.props.match.params.salonId}`)}
                            >
                                Booking
                            </span>
                            <span
                                className="nav-item nav-link"
                                onClick={() => this.props.history.push(`/event/${this.props.match.params.salonId}`)}
                            >
                                Event
                            </span>
                            <span className="nav-item nav-link active">
                                Leave
                            </span>
                        </nav>
                    )}

                    <div className="booking-parent booking_space__fix">
                        <div className="tab_content_wrapper">
                            <div className="booking_form_wrapper bg-white">
                                {this.state.isLoading && (
                                    <div className="text-center p-4">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading leave data...</p>
                                    </div>
                                )}


                                <div className="cm_row m-0">
                                    <div className="cm_100">
                                        <div className={!this.state.hairdresserId ? "input_group_u _staff_member border_blue" : 'input_group_u _staff_member'}>
                                            <span className="_field_label_vk">Staff Member</span>
                                            <Select
                                                key={`staff-select-${this.state.hairdresserId || 'empty'}`}
                                                options={this.getStaffOptions()}
                                                value={this.getSelectedStaffOption()}
                                                onChange={this.changeHairdresser}
                                                placeholder="Select Staff Member"
                                                isClearable
                                            />
                                        </div>
                                        {this.state.hairdresserError && (
                                            <span className="text-danger">{this.state.hairdresserError}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="cm_row m-0 leave-datepicker-container">
                                    <div className="leave-datepicker-item" style={{ width: '100%' }}>
                                        <div className={this.state.leaveTitleError ? "input_group_u border_blue" : 'input_group_u'}>
                                            <span className="_field_label_vk">Leave Title</span>
                                            <div className="pt-0 bg-white w-100 p-0" style={{ position: 'relative', border: 'none', borderRadius: '4px' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="e.g. Holiday"
                                                    value={this.state.leaveTitle}
                                                    onChange={this.handleLeaveTitleChange}
                                                    style={{
                                                        width: '100%',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        padding: '15px',
                                                        fontSize: '16px',
                                                        lineHeight: '1.5',
                                                        boxSizing: 'border-box',
                                                        outline: 'none',
                                                        height: '50px',
                                                        display: 'block',
                                                        backgroundColor: 'transparent'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {this.state.leaveTitleError && (
                                            <span className="text-danger">{this.state.leaveTitleError}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="cm_row m-0 leave-datepicker-container">
                                    <div className="leave-datepicker-item">
                                        <div className={!this.state.startDate ? "input_group_u border_blue" : 'input_group_u'}>
                                            <span className="_field_label_vk">Start Date</span>
                                            <div className="pt-0 bg-white service_select ___service border-1 w-100 p-0" style={{ position: 'relative' }}>
                                                <div className="service_checkout_datepicker _datepickr">
                                                    <DatePicker
                                                        selected={this.state.startDate}
                                                        minDate={new Date()}
                                                        className="__datepicker"
                                                        onChange={this.handleStartDateChange}
                                                    />
                                                    <p className="show__date" style={{ position: 'absolute', top: '50%', left: '15px', transform: 'translateY(-50%)', margin: 0, pointerEvents: 'none', zIndex: 10 }}>{this.state.startDate ? moment(this.state.startDate).format("dddd, D MMM YYYY") : "Select Start Date"}</p>
                                                </div>
                                            </div>
                                            {this.state.startDateError && (
                                                <span className="text-danger">{this.state.startDateError}</span>
                                            )}
                                        </div>
                                    </div>
                                    
                                    <div className="leave-datepicker-item">
                                        <div className={!this.state.endDate ? "input_group_u border_blue" : 'input_group_u'}>
                                            <span className="_field_label_vk">End Date</span>
                                            <div className="pt-0 bg-white service_select ___service border-1 w-100 p-0" style={{ position: 'relative' }}>
                                                <div className="service_checkout_datepicker _datepickr">
                                                    <DatePicker
                                                        selected={this.state.endDate}
                                                        minDate={this.state.startDate}
                                                        className="__datepicker"
                                                        onChange={this.handleEndDateChange}
                                                    />
                                                    <p className="show__date" style={{ position: 'absolute', top: '50%', left: '15px', transform: 'translateY(-50%)', margin: 0, pointerEvents: 'none', zIndex: 10 }}>{this.state.endDate ? moment(this.state.endDate).format("dddd, D MMM YYYY") : "Select End Date"}</p>
                                                </div>
                                            </div>
                                            {this.state.endDateError && (
                                                <span className="text-danger">{this.state.endDateError}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {this.state.isEditMode && (
                                    <div className="cm_row m-0">
                                        <div className="cm_100">
                                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                <button
                                                    onClick={this.deleteLeave}
                                                    className="btn btn-pink pl-4 pr-4"
                                                >
                                                    Delete Leave
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Footer for mobile devices */}
            {window.innerWidth <= 768 && (
                <div className="footerbtn-parent mt-5 mb-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 d-flex footer-btn fix-footer">
                                <button className="btn btn-bhite btn-block" onClick={this.mobileCancel}>Cancel</button>
                                <button
                                    className="btn btn-blue btn-block"
                                    onClick={this.mobileContinue}
                                    disabled={this.state.isMobileEnableState}
                                >
                                    {this.state.isEditMode ? 'Update Leave' : 'Save Leave'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(Leave);